import googleTagManager from '@analytics/google-tag-manager';
import { Analytics as defaultAnalytics, AnalyticsInstance } from 'analytics';

import { analyticAuth } from '../constants/analyticAuth';

export const createAnalyticsInstance = (
  Analytics = defaultAnalytics,
): AnalyticsInstance => {
  const currentEnvironment: string = import.meta.env
    .VITE_APP_TARGET_ENVIRONMENT;

  // Return a no-op analytics instance if environment is not configured
  if (!(currentEnvironment in analyticAuth)) {
    return Analytics(null);
  }

  const { googleTagManagerAuth } = analyticAuth[currentEnvironment];

  return Analytics({
    app: 'consumer-portal',
    plugins: [googleTagManager(googleTagManagerAuth)],
  });
};
